export default __webpack_public_path__ + "static/media/dunky.a896e027.png";